import { render, staticRenderFns } from "./demand-request.vue?vue&type=template&id=304563d8&scoped=true&"
import script from "./demand-request.vue?vue&type=script&lang=js&"
export * from "./demand-request.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/demand-request.scss?vue&type=style&index=0&id=304563d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304563d8",
  null
  
)

export default component.exports